module.exports = __webpack_public_path__ + "img/occupation_inf_2.f3fc34f2.png";